import {Uuid} from '@raison/types';
import {type} from 'arktype';
import {TransactionHolder} from '~/entities/operations-crypto';

export const TransactionHolderSchema = type({
    key: 'string',
    sign: 'number[]',
    tx: 'string',
    uuid: type('string.uuid').as<Uuid>(),
    two_fa_box_uuid: type('string.uuid').as<Uuid>(),
    tenant_uuid: type('string.uuid').as<Uuid>(),
    expires_in: 'number',
}).onUndeclaredKey('delete') satisfies {
    infer: TransactionHolder;
};
